import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Snackbar } from '@mui/material';
import { createContext, useContext, useState } from 'react';
const SnackbarContext = createContext(undefined);
export const useSnackbar = () => {
    const ctx = useContext(SnackbarContext);
    if (!ctx)
        throw new Error('useSnackbar must be used within SnackbarProvider');
    return ctx;
};
export const SnackbarProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('info');
    const showSnackbar = (msg, sev = 'info') => {
        setMessage(msg);
        setSeverity(sev);
        setOpen(true);
    };
    const handleClose = () => setOpen(false);
    return (_jsxs(SnackbarContext.Provider, { value: { showSnackbar }, children: [children, _jsx(Snackbar, { open: open, autoHideDuration: 3000, onClose: handleClose, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, children: _jsx(Alert, { onClose: handleClose, severity: severity, variant: "filled", children: message }) })] }));
};
